import { File } from '../files/files.model';

export class Testimonial {
    id?: string;
    title?: any;
    excerpt?: any;
    content?: any;
    custom_seo_data?: any;
    seo_title?: any;
    seo_description?: any;
    contained?: IContained;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.excerpt = options.excerpt;
        this.content = options.content;
        this.custom_seo_data = options.custom_seo_data;
        this.seo_title = options.seo_title;
        this.seo_description = options.seo_description;
        this.contained = options.contained;
    }
}

interface IContained {
    files?: Array<File>;
    categories?: Array<any>;
}
